export default __webpack_public_path__ + "static/media/customer.74e5ef49.svg";